import type { LogEntry } from "../types";

export function Log({ entries }: { entries: LogEntry[] }) {
  return (
    <div className="log" role="log" aria-label="Activity log">
      {entries
        .slice()
        .reverse()
        .slice(0, 100)
        .map((e, i) => (
          <div className="row" key={`${e.at}-${i}`}>
            <span className={`kind ${e.kind}`}>{e.kind}</span>
            <span className="text">{e.text}</span>
          </div>
        ))}
    </div>
  );
}
